import React from 'react'

import { IndevaIFrame } from '../../../../core/components/IndevaIFrame'

export const Rankings = () => {
  return <IndevaIFrame path="rankings/group" />
}
